import React from 'react';

const About = () => (
  <div>
    <p>Back in 2013, I embarked on a journey to develop Android apps, diving deep into the realm of software engineering and web development. Fast forward to today, I have over 9 years of experience specializing in Android development.</p>
    <p>My primary focus now is on enhancing user experiences through innovative and efficient solutions.</p>
    <p>In addition to my development expertise, I have a solid foundation in mathematics and AI. With extensive experience in 17 branches of mathematics, I have demonstrated exceptional problem-solving skills.</p>
    <p>When I'm not coding, I indulge in financial trading, applying my analytical skills to manage virtual portfolios successfully. As a dedicated karateka, I embody discipline and perseverance.</p>
    <p>I'm passionate about driving technological advancements and making meaningful contributions. Book a consultation with me today to collaborate on bringing your ideas to life, whether through web or mobile development.</p>
  </div>
);

export default About;
